import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import { Grid, Card, CardContent, Typography } from "@mui/material/";
import { connect } from "react-redux";
import { fetchResult, fetchFeelLucky } from "../state/middleware";
import { selectSelectedValues } from "..//state/selectors";
import { setStatus, resetQuestions } from "../state/domains";
import Box from "@mui/material//Box";
import LinearProgress from "@mui/material//LinearProgress";
import useMediaQuery from "@mui/material/useMediaQuery";
const ResultCard = props => {
  const {
    _fetchResult,
    result,
    status,
    _fetchFeelLucky,
    _setStatus,
    _resetQuestions,
    loading,
  } = props;
  const useStyles = makeStyles(theme => ({
    resultCard: {
      backgroundColor: "white",
      display: "flex",
      minHeight: "100%",
    },
    nameResult: {
      color: "#5ccc47",
      "font-size": "1.4em",
    },
  }));
  const buttons = (
    <>
      <Grid
        container
        spacing={2}
        direction="row"
        alignItems="center"
        sx={{ "margin-top": "1.5em" }}
        justifyContent="center">
        <Grid item>
          <Button
            color="button"
            variant="contained"
            onClick={e => {
              _setStatus(3);
              _fetchFeelLucky();
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }}>
            I feel Lucky!{" "}
          </Button>
        </Grid>
        <Grid item>
          <Button
            //sx={{ "background-color": "#5a6670" }}
            color="button"
            variant="contained"
            onClick={e => {
              _resetQuestions();
              _setStatus(1);
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }}>
            Start Over
          </Button>{" "}
        </Grid>
      </Grid>
    </>
  );
  const [showCount, setShowCount] = useState(20);

  useEffect(() => {
    if (status === 2) _fetchResult();
    else _fetchFeelLucky();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  if (loading)
    return (
      <Box sx={{ width: "100%", position: "absolute", top: "50%" }}>
        <LinearProgress />
      </Box>
    );
  else if (result.length === 0)
    return (
      <Box sx={{ width: "100%", position: "absolute", top: "50%" }}>
        <Card className={classes.resultCard}>
          <CardContent>
            <span>
              No Result Matched your selection , Please expand your search
            </span>
          </CardContent>
        </Card>
        {buttons}
      </Box>
    );
  else
    return (
      <>
        <Grid container spacing={2} direction="row">
          {result.slice(0, showCount).map(nameData => {
            let charDisplay = [];
            if (nameData.meaning) {
              charDisplay.push(
                <Box component="span">
                  {" "}
                  Meaning: {nameData.meaning} <br />
                </Box>
              );
            }
            let chars = mergeNamecharacters(JSON.parse(nameData.Characters));
            setCharacters(charDisplay, chars);
            return (
              <Grid item xs={12} sm={6} md={3} key={result.indexOf(nameData)}>
                <Card className={classes.resultCard}>
                  <CardContent>
                    <Box
                      className={classes.nameResult}
                      gutterBottom
                      component="div">
                      {nameData.name}
                    </Box>
                    {charDisplay}
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
          {result.length > showCount && (
            <Grid item>
              {" "}
              <Button
                variant="outlined"
                color="loadmore"
                onClick={e => {
                  setShowCount(showCount + 20);
                }}>
                Load More...
              </Button>{" "}
            </Grid>
          )}
        </Grid>
        {buttons}
      </>
    );
};
const mapStateToProps = state => {
  const result = state.result.quizResultData;
  return {
    result,
    loading: state.result.loading,
    status: state.quiz.status,
  };
};
function mapDispatchToProps(dispatch) {
  const selectedValue = selectSelectedValues();
  return {
    _fetchResult: () => dispatch(fetchResult(selectedValue)),
    _fetchFeelLucky: () => dispatch(fetchFeelLucky()),
    _setStatus: status => dispatch(setStatus(status)),
    _resetQuestions: () => dispatch(resetQuestions()),
  };
}
function setCharacters(charDisplay, chars) {
  charDisplay.push(
    Object.keys(chars).map(key => {
      return (
        <span>
          {" "}
          {key}: {chars[key]} <br />
        </span>
      );
    })
  );
}
function mergeNamecharacters(charobjArray) {
  let obj = charobjArray.reduce((prev, curr) => {
    for (const prop in curr) {
      if (prop in prev) {
        prev[prop] = prev[prop] + "," + curr[prop];
      } else prev[prop] = curr[prop];
    }
    return prev;
  }, {});

  return obj;
}

export default connect(mapStateToProps, mapDispatchToProps)(ResultCard);
